module.exports = __webpack_public_path__ + "pc/img/list_bg.8682c4fa.png";